module.exports = __webpack_public_path__ + "img/RedHat.0d3693b.svg";